import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const TableHeader = ({ children }) => (
  <thead className={styles.header}>
    <tr className={styles.row}>
      {React.Children.map(children, child => {
        // Ignore any null children
        if (!child) return null

        // Extract the width property and clear it
        const width = child ? child.props.width : undefined
        return (
          <th className={styles.cell} width={width}>
            {React.cloneElement(child, { width: undefined })}
          </th>
        )
      })}
    </tr>
  </thead>
)

TableHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default TableHeader
